import script from "./TransitionPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransitionPicker.vue?vue&type=script&lang=ts&setup=true"

import "./TransitionPicker.vue?vue&type=style&index=0&id=ed11517e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed11517e"]])

export default __exports__